<script>
  import { fromUnixTime, format } from 'date-fns';
  import { convertToTimeZone } from 'date-fns-timezone';
  import defaultImage from '@/assets/img/default_profile_normal.png';
  export default {
    name: 'Answer',
    props: {
      tweet: {
        type: Object,
        default: {},
      },
    },
    methods: {
      convTime: function(unixtime) {
        return format(fromUnixTime(unixtime), 'yyyy/MM/dd');
      },
      setAltSrc: function() {
        this.tweet.profile_picture = defaultImage;
        return 
      }
    }
  }
</script>

<template lang="pug">
  a.answer(
    :href = "tweet.link_url"
    target = "_blank"
    )
    img.answer-icon(
      :src = "tweet.profile_picture"
      @error = "setAltSrc"
      )
    .answer-inner
      .answer-head
        .answer-names
          .answer-name
            |{{tweet.username}}
          .answer-id
            |{{tweet.screen_name}}
        .answer-date
          |{{convTime(tweet.post_time_stamp)}}
      .answer-body
        .answer-comment
          |{{tweet.caption}}
        .answer-like-and-rt
          .answer-likes
            img(
              src = "~@/assets/img/twitter_like.svg"
              )
            |{{tweet.like_count}}
          .answer-rts
            img(
              src = "~@/assets/img/twitter_re.svg"
              )
            |{{tweet.rt_count}}
</template>

<style lang="scss">
  .answer {
    display: flex;
    border-top: 1px solid $primary-color-pale;
    padding-top: 12px;
    padding-left: 16px;
    padding-right: 15px;
    box-sizing: border-box;
    text-decoration: none;
    color: $primary-text;
    &-icon {
      width: 52px;
      height: 52px;
      border-radius: 50%;
    }
    &-inner {
      width: calc(100% - 52px);
      padding-left: 8px;
    }
    &-head {
      display: flex;
      justify-content: space-between;
    }
    &-name, &-display, &-comment {
      @include fontSizeAll(14, 14);
    }
    &-names {
      display: flex;
      flex-wrap: wrap;
    }
    &-body {
      line-height: 1.43;
    }
    &-name {
      font-family: 'HiraginoSans-W6';
    }
    &-comment {
      font-family: 'HiraginoSans-W3';
    }
    &-display {
      @include fontSizeAll(14, 14);
      font-weight: bold;
    }
    &-id, &-date {
      @include fontSizeAll(15, 15);
      font-family: $font-id;
      color: #677887;
      white-space: nowrap;
    }
    &-date {
      padding-left: 1em;
    }
    &-id {
      margin-left: 2px;
      &::before {
        content: '@';
      }
    }
    &-like-and-rt {
      display: flex;
      margin-top: 10px;
      margin-bottom: 13px;
    }
    &-likes, &-rts {
      @include fontSizeAll(15, 15);
      color: #677887;
    }
    &-likes {
      display: flex;
      img {
        margin-right: 7px;
      }
    }
    &-rts {
      display: flex;
      margin-left: 32px;
      img {
        margin-right: 5px;
      }
    }
  }
</style>
